export default __webpack_public_path__ + "static/media/CoinJar.3f806883.svg";